<template>
  <div>
    <div class="conandack" id="conandack" v-if="this.conContributions && this.conContributions.length > 0">
      <h2 class="theme-background">{{ARTICLE.defaultlang=='zh'?'作者贡献声明':'Contributions Statement'}}</h2>
      <div v-for="contribution in this.conContributions">
        <component :is="'jo' + item.name" v-for="item in contribution.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>
    <div class="conandack" id="conandack-equal" v-if="this.equalContributions && this.equalContributions.length > 0">
      <h2 class="theme-background">{{ARTICLE.defaultlang=='zh'?'同等贡献声明':'Equal Contributions Statement'}}</h2>
      <div v-for="contribution in this.equalContributions">
        <component :is="'jo' + item.name" v-for="item in contribution.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>
    <div class="conandack" id="acknowledgements" v-if="this.acknowledgements && this.acknowledgements.length > 0">
      <h2 class="theme-background">{{ARTICLE.defaultlang=='zh'?'致谢':'Acknowledgements'}}</h2>
      <div v-for="acknowledgement in this.acknowledgements">
      <component :is="'jo' + item.name" v-for="item in acknowledgement.data" v-bind:key="item.index" v-bind:data="item.data"></component>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        contributions: this.ARTICLE.contributions,
        acknowledgements: this.ARTICLE.acknowledgements,
        conContributions:[],
        equalContributions:[]
      }
    },
    created() {
      if(this.contributions && this.contributions.length > 0){
        for(let i=0;i<this.contributions.length;i++){
          if (this.contributions[i].type ==='con'){
            this.conContributions.push(this.contributions[i]);
          } else if (this.contributions[i].type ==='equal'){
            this.equalContributions.push(this.contributions[i]);
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/maincontent/body/conandack/conandack.vue